import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=cb6b6174&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=cb6b6174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6b6174",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb6b6174')) {
      api.createRecord('cb6b6174', component.options)
    } else {
      api.reload('cb6b6174', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=cb6b6174&scoped=true&", function () {
      api.rerender('cb6b6174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20obWn0Xya0Tn/JS/comp/GuestBox.vue"
export default component.exports